// Registry for the `screen:<id>` figure token used by docs/concepts/*.md.
// pages/ConceptPage.js resolves `![caption](screen:ambient-day)` to
// the component here and renders it inside the same <figure>.
import { AmbientDay, AmbientBoards, ProjectionGlow, ScheduleEditor } from './loop';
import { ActivePortal, GateOnGlass } from './portal';

export const AMBIENT_SCREENS = {
  'ambient-day': AmbientDay,
  'ambient-boards': AmbientBoards,
  'active-portal': ActivePortal,
  'gate-on-glass': GateOnGlass,
  'projection-glow': ProjectionGlow,
  'schedule-editor': ScheduleEditor,
};
